<ng-content></ng-content>
@if (shouldDisplayMapTabs && shouldDisplayTabs()) {
    <h-tab-list
        [defaultSelectedTab]="isMapMobile() ? 1 : 0"
        [scrollTopOnTabChange]="false"
        (selectedTabChange)="setSelected($event)"
        [attr.data-testid]="'shop-locator-mode-tab-list'">
        <h-tab-item data-testid="list-view-tab">
            <ng-template [hTabTitle]>
                <h-svg-icon [name]="'list-view'" class="list-icon"></h-svg-icon>
                <p i18n="@@page--hermes-global--find-store.list-view" class="delivery-tab-title"> List view </p>
            </ng-template>
        </h-tab-item>

        <h-tab-item data-testid="map-view-tab">
            <ng-template [hTabTitle]>
                <h-svg-icon [name]="'map-view'"></h-svg-icon>
                <p i18n="@@page--hermes-global--find-store.map-view" class="delivery-tab-title"> Map view </p>
            </ng-template>
        </h-tab-item>
    </h-tab-list>
}
